<template>
  <div class="container supply">
    <div class="row">
      <div class="col supply_title">
        <Title current-name="Поставщикам">
          Вы поставщик для HoReCa?
        </Title>
        <div class="supply_subtitle">
          Мы ценим надёжных бизнес партнёров и всегда открыты к сотрудничеству...
        </div>
      </div>
    </div>
    <SupplyForm />
    <Modal :open="modalOpen" @close="modalOpen = false" :initialWidth="'504px'" :borderless="true">
      <contacts-success @close="modalOpen = false" />
    </Modal>
  </div>
</template>

<script>
import Title from '@/components/UI/Title'
import SupplyForm from '@/components/page/SupplyForm'
import Modal from '~/components/page/Modal/Modal'
import ContactsSuccess from '~/components/popup/ContactsSuccess'

export default {
  components: { ContactsSuccess, Modal, Title, SupplyForm },
  head () {
    return {
      title: 'Вы поставщик для HoReCa? | СУШИСЕТ',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Мы ценим надёжных бизнес партнёров и всегда открыты к сотрудничеству. Заполните форму и мы свяжемся с вами.',
        },
      ],
    }
  },
  data () {
    return {
      modalOpen: false,
    }
  },
  computed: {
    status () {
      return this.$store.getters['dictionaries/getStatus']
    },
  },
  watch: {
    status (newValue) {
      switch (newValue) {
        case 'cooperation-form-successfully-fetched':
          this.modalOpen = true
          break
      }
    },
  },
}
</script>

<style lang="less">
.supply {
	padding-top: 20px;

	&_title {
		margin-bottom: 62px;

		@media screen and (max-width: 768px) { margin-bottom: 8px; }
	}

	&_subtitle {
		font-family: 'Roboto', Arial, sans-serif;
		font-weight: 300;
		font-size: 14px;
		margin-top: 10px;

		@media screen and (max-width: 768px) {
			margin-top: 8px;
			text-align: center;
		}
	}

	&-form {
		margin-bottom: 104px;

		@media screen and (max-width: 768px) { margin-bottom: 25px; }
	}

	@media screen and (max-width: 992px) {
		padding-top: 50px;
	}
}
</style>
